"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkWrapper = exports.RowWrapper = exports.SubHeader = exports.Header = exports.AdvancedItems = exports.Items = exports.Section = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const colors_1 = require("../../../theme/colors");
exports.Section = styled_components_1.default.section ``;
exports.Items = styled_components_1.default.div `
  display: flex;
  flex-wrap: wrap;
  margin: 0;

  & > div {
    width: 100%;
  }

  @media (min-width: 1301px) and (max-width: 1640px) {
    ${({ $twoColumns }) => $twoColumns &&
    (0, styled_components_1.css) `
        margin: 0 -8px 0;
      `}

    & > div {
      ${({ $twoColumns }) => $twoColumns &&
    (0, styled_components_1.css) `
          width: 50%;
          padding: 0 16px;
        `}
    }

    & > div:nth-child(odd) {
      ${({ $twoColumns }) => $twoColumns &&
    (0, styled_components_1.css) `
          border-right: 1px solid ${colors_1.LIGHT_GREY};
        `}
    }

    & > div:nth-child(even) {
      ${({ $twoColumns }) => $twoColumns &&
    (0, styled_components_1.css) `
          border-right: 1px solid transparent;
        `}
    }
  }
`;
exports.AdvancedItems = (0, styled_components_1.default)(exports.Items) `
  @media (min-width: 1301px) and (max-width: 1640px) {
    & > div:nth-child(even) {
      ${({ $twoColumns }) => $twoColumns &&
    (0, styled_components_1.css) `
          border-right: 1px solid transparent;
        `}
    }

    & > div:nth-child(odd) {
      ${({ $twoColumns }) => $twoColumns &&
    (0, styled_components_1.css) `
          border-right: 1px solid transparent;
        `}
    }
  }
`;
exports.Header = styled_components_1.default.h5 `
  font-size: 14px;
  color: ${colors_1.GREY4};
  margin: 2px 8px 5px;
  width: 100%;
`;
exports.SubHeader = styled_components_1.default.h5 `
  font-size: 14px;
  color: ${colors_1.GREY4};
  margin: 0 8px;
  width: auto;
  display: inline-block;
  min-height: 32px;
  vertical-align: middle;
  line-height: 32px;
`;
exports.RowWrapper = styled_components_1.default.div `
  background-color: ${colors_1.WHITE};
`;
exports.LinkWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
`;
//# sourceMappingURL=CalculationSectionCompact.styles.js.map